import React, { useEffect, useState } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import RouteComponent from './routeComponent';
import RouteSwitch from './routeSwitch';
import routes from '../../plugins/routes';
import { LOGIN_PAGE_REDIRECT_URL, PAGE_URLS } from '../../helpers/endpoints';

export default ({ configJson }) => {
  return (
    <Switch>
      <Route
        path={PAGE_URLS.LOGIN}
        component={() => {
          const getConfig = async () => {
            const { origin } = window.location;
            const loginRedirectUrl = LOGIN_PAGE_REDIRECT_URL.replace(
              '[AUTH_UI_ADDRESS]',
              configJson.REACT_APP_AUTH_UI_ADDRESS,
            ).replace('[origin]', origin);
            window.location.href = loginRedirectUrl;            
          };

          getConfig();
          return null;
        }}
      />

      {routes.map((x, i) =>
        x.redirect ? (
          <Redirect key={i} from={x.path} to={x.redirect} />
        ) : (
          <Route
            key={i}
            exact={x.routes ? x.routes.some((y) => y.exact) : x.exact}
            path={x.routes ? x.routes.map((y) => y.path) : x.path}
          >
            <x.component>
              {x.routes &&
                x.routes.map((y, j) => (
                  <Route
                    key={j}
                    path={y.path}
                    render={(props) =>
                      y.routes ? (
                        <RouteSwitch
                          {...props}
                          path={y.path}
                          routes={y.routes}
                        />
                      ) : (
                        <RouteComponent {...props} route={y} />
                      )
                    }
                  />
                ))}
            </x.component>
          </Route>
        ),
      )}
      {/* <Redirect to="/dashboard" /> */}
    </Switch>
  );
};
